import React, { useEffect, useState } from 'react'
import Layout from '../../components/layout/layout'
import AddAsset from '../../components/assets/asset-mangament/create-asset/asset-modal.component'
import styles from './asset-management.module.css'
import ConfigureAsset from '../../components/configuration-templates/asset-configuration-modal-component'
import AssetView, {
  AssetViewContext,
} from '../../components/assets/asset-info-view/assetView'
import SpeedDials from '../../components/assets/asset-mangament/assets-actions'
import { DEVICE_STATUS_ENUM } from '../../services/device'
import ProvisionConfirmDialog from '../../components/assets/asset-provision/confirm-dialog'
import AssetBulkUpload from '../../components/bulk-upload/assetBulkUpload'
import AssetList from '../../components/assets/asset-list/assetList.component'
import AssignModal from '../../components/assets/asset-mangament/link-asset/assign-asset-modal'

export default function AssetManagement() {
  const [viewAsset, setViewAsset] = useState(false)
  const [assetData, setAssetData] = useState(false)
  const [assetCustomerData, setAssetCustomerData] = useState(false)
  const [show, setShow] = useState(false)
  const [openTemplateDialog, setOpenTemplateDialog] = useState(false)
  const [assignAssetModal, setAssetAssignModal] = useState(false)
  const [showConfirmDialog, setShowConfirmDialog] = useState(false)
  const [showAssetBulk, setAssetBulkShow] = useState(false)

  useEffect(() => {
    setViewAsset(false)
  }, [])

  return (
    <Layout>
      <AssetViewContext.Provider
        value={{
          viewAsset,
          setViewAsset,
          assetData,
          setAssetData,
          assetCustomerData,
          setAssetCustomerData,
          openTemplateDialog,
          showAssetBulk,
          setAssetBulkShow,
          setOpenTemplateDialog,
          assignAssetModal,
          setAssetAssignModal,
          showConfirmDialog,
          setShowConfirmDialog,
        }}
      >
        <div className={styles.container}>
          {viewAsset ? (
            <AssetView />
          ) : (
            <>
              <AssetList
                className={styles.list}
                status={DEVICE_STATUS_ENUM.ALL}
              />
              <SpeedDials
                show={show}
                setShow={setShow}
                showAssetBulk={showAssetBulk}
                setAssetBulkShow={setAssetBulkShow}
              />
              <AddAsset
                show={show}
                setShow={setShow}
                className={styles.actions}
              />
              <ConfigureAsset />
              <AssignModal />
              <ProvisionConfirmDialog
                showConfirmDialog={showConfirmDialog}
                setShowConfirmDialog={setShowConfirmDialog}
                device={assetData}
              />
              <AssetBulkUpload
                showAssetBulk={showAssetBulk}
                setAssetBulkShow={setAssetBulkShow}
              />
            </>
          )}
        </div>
      </AssetViewContext.Provider>
    </Layout>
  )
}
